<div class="fixed inset-0 z-50 flex items-center justify-end" aria-labelledby="slide-over-title" role="dialog"
    aria-modal="true">
    <div class="fixed inset-0 bg-[#363738] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]"></div>
    <!-- Modal Container -->
    <div
        class="relative z-50 h-full w-screen max-w-4xl overflow-y-auto rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">
        <div class="border-b border-zinc-200 px-4 py-2 dark:border-white/10">
            <div class="flex items-center justify-between">
                <h3 class="heading" id="slide-over-title"> Trails</h3>
                <div class="ml-3 flex h-7 items-center space-x-4">
                    <button (click)="onCloseModal()"
                        class="rounded-sm bg-white text-zinc-500 hover:text-zinc-700 focus:ring-2 focus:ring-primary dark:bg-white/5 dark:text-white dark:hover:text-zinc-300"
                        type="button">
                        <span class="sr-only">Close panel</span>
                        <svg aria-hidden="true" class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.5"
                            viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <!-- Map Section -->
        <div class="p-4">
            <div class="flex items-center gap-1 text-primary mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="size-4" viewBox="0 0 24 24">
                    <path fill="currentColor"
                        d="m15 21l-6-2.1l-4.65 1.8q-.5.2-.925-.112T3 19.75v-14q0-.325.188-.575T3.7 4.8L9 3l6 2.1l4.65-1.8q.5-.2.925.113T21 4.25v14q0 .325-.187.575t-.513.375zm-1-2.45V6.85l-4-1.4v11.7zm2 0l3-1V5.7l-3 1.15zM5 18.3l3-1.15V5.45l-3 1zM16 6.85v11.7zm-8-1.4v11.7z" />
                </svg>
                <h2 class="subheading text-primary">Map</h2>
            </div>
            <div class=" h-[580px] overflow-hidden rounded-lg border border-zinc-950/10 dark:border-white/10">
                <google-map #map class="h-full w-full"
                    [center]="events.length ? { lat: events[0].latitude, lng: events[0].longitude } : { lat: 0, lng: 0 }"
                    [zoom]="16">
                    <map-marker *ngFor="let item of events; let i = index"
                        [position]="{ lat: item.latitude, lng: item.longitude }" [label]="getMarkerLabel(i)">
                    </map-marker>
                    <map-polyline [path]="polylinePath"
                        [options]="{ strokeColor: '#2196f3', strokeOpacity: 1.0, strokeWeight: 4 }">
                    </map-polyline>

                </google-map>
            </div>

        </div>
    </div>
</div>